/// <reference path="ListBase.js" />

class GNOMList extends ListBase {
	constructor(el, options) {
		super(el, Object.assign({ pagingEffect: 'horizSlide', noProgressIndicator: false }, options));
		this.emptyel = this.el.querySelector('.emptyList a');
		this.el.attachedObj = this;

		if (this.emptyel != undefined && this.options.emptyListUrl != undefined)
			this.safeObserve(this.emptyel, 'click', this.onClick.bind(this));
	}

	loadPage(page, customUrl) {
		super.loadPage(page);

		if (customUrl == undefined)
			this.standardJSONRequest(this.options.url.replace('PLH_pagenum', page));
		else
			this.standardJSONRequest(customUrl.replace('PLH_pagenum', page));
	}

	onClick(ev) {
		this.el.closest('.tabbedApplication').attachedObj.findAndLoadTab(this.options.emptyListUrl);
		ev.preventDefault();
		ev.stopPropagation();
	}
}
